import { ICuratedCategoryApiModel } from './api/curated-category.api.model';
import { IPlaceApiV5Model } from './api/place.api.model';
import { PlaceModel } from './place.model';

export class CuratedCategoryModel {
  id: number;
  title: string;
  filter: string;
  description: string;
  emojis: Array<string>;
  icon: string;
  image: string;
  isFilter: boolean;
  isTag: boolean;
  isFeatured: boolean;
  isPublished: boolean;
  placeIds: Array<number>;
  places: Array<{
    id: number;
    place: IPlaceApiV5Model;
    description: string;
  }> | null;
  slug: string;

  get placeList(): Array<PlaceModel> {
    return Array.isArray(this.places)
      ? this.places.map(el => new PlaceModel(el.place))
      : [];
  }

  constructor(source?: ICuratedCategoryApiModel) {
    if (source == null) {
      return;
    }

    this.id = source.id;
    this.title = source.title;
    this.filter = source.title_filter;
    this.description = source.description_page?.body ?? source.description;
    this.emojis = source.emojis;
    this.icon = source.icon;
    this.image = source.image;
    this.isFilter = source.is_filter;
    this.isTag = source.is_tag;
    this.isFeatured = source.is_featured;
    this.isPublished = source.is_published;
    this.placeIds = source.place_ids;
    this.places = source.places;
    this.slug = source.slug;
  }

  static copyObj(
    source: Pick<CuratedCategoryModel, keyof CuratedCategoryModel>,
  ): CuratedCategoryModel {
    return Object.assign(new CuratedCategoryModel(), source);
  }
}
